import React from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl brand-gradient-soft flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-[#4F46E5]" strokeWidth={1.6} />
      </div>
      <h3 className="text-[16px] font-semibold text-[#1A1B2E] mb-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{title}</h3>
      {description && <p className="text-[13px] text-[#6B6C85] max-w-[380px] mb-5">{description}</p>}
      {action}
    </div>
  );
}
